<template>
  <div id="mypage">
    <el-container>
      <el-header><i class="fas fa-address-card fa-fw"></i> マイページ</el-header>
      <el-main>
        <el-row>
          <el-col :span="24">
            <el-card class="box-card" style="color: #606266">
              <template #header>
                <div class="card-header"><i class="el-icon-info"></i><span>Information</span></div>
              </template>
              <el-collapse v-model="activeNames">
                <el-collapse-item :title="pointTitle" name="1">
                  <p>マイページでは、以下のことができます。</p>
                  <ol>
                    <li>ご自分の登録情報の変更</li>
                    <li>発注履歴の管理</li>
                    <li>保存見積もりの管理</li>
                  </ol>
                </el-collapse-item>
                <el-collapse-item title="利用規約" name="2">
                  <ol>
                    <li>
                      入力データの利用について
                      <ul>
                        <li>
                          入力された反響データは、御社が反響データを蓄積・分析していただく以外に、弊社が導入しているGISマーケティングツール等を活用して、御社に対して、より反響が出る配布エリア選定のご提案をさせていただくために利用させていただくことがあります。
                        </li>
                        <li>
                          入力いただいたデータはそのままの形で許可なく第三者に提供することはありません。なお、統計処理等を用いてエリアの特性（プロファイル）として皆様にご提供させていただくことがあります。
                        </li>
                      </ul>
                    </li>
                  </ol>
                  <div style="text-align: right">
                    2021年5月1日<br />ポストエクスプレス株式会社
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-card>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          justify="space-between"
          style="margin-top: 10px"
        >
          <el-col :span="8" style="text-align: center">
            <router-link to="/usrinfo">
              <el-button type="primary" icon="el-icon-user">登録情報</el-button>
            </router-link>
          </el-col>
          <el-col :span="8" style="text-align: center">
            <router-link to="/hist">
              <el-button type="primary" icon="el-icon-s-order">発注管理</el-button>
            </router-link>
          </el-col>
          <el-col :span="8" style="text-align: center">
            <router-link to="/savedest">
              <el-button type="primary" icon="el-icon-s-claim">保存見積</el-button>
            </router-link>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          justify="center"
          style="margin-top: 10px"
        >
          <el-col :span="4">
            <router-link to="/">
              <el-button type="info">戻る</el-button>
            </router-link>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  props: ['user'],
  setup(props) {
    const router = useRouter()
    const pointTitle = 'こんにちは、' + props.user.name + 'さん'
    const activeNames = [1]
    if(!props.user.login) {
      console.log('Can\'t access MyPage for not login.')
      router.back()
    }

    return {
        pointTitle,
        activeNames
    }
  }
})
</script>

<style scoped>
#mypage {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#mypage .el-form {
  text-align: left;
}
#mypage .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#mypage .el-container {
  width: 450px;
  margin: 0 auto;
}
.el-collapse {
  text-align: left;
}
</style>